/**
 * Branding de Jogacompix.
 *
 * Antes este modulo elegia entre las marcas AYG y RYG segun el hostname
 * (`jogacompix.com` servia RYG y todo lo demas AYG). Jogacompix es una marca unica:
 * no hay bifurcacion por hostname ni segundo logo, asi que las funciones devuelven
 * siempre el mismo asset y se mantiene la firma para no tocar los consumidores.
 */

import jcpIcon from "../assets/images/brand/jcp-icon.png";
import jcpWordmark from "../assets/images/brand/jcp-wordmark.png";

export const BRAND_TITLE = "Jogacompix";

/**
 * Logo horizontal de la marca. Sirve igual en tema claro y oscuro porque el wordmark
 * lleva fondo transparente.
 */
export const getLogoByHostname = () => jcpWordmark;

/** Titulo de marca. */
export const getBrandTitleByHostname = () => BRAND_TITLE;

/** Hook con el logo actual (misma imagen en ambos temas). */
export const useLogo = () => jcpWordmark;

/** Hook con el titulo de marca. */
export const useBrandTitle = () => BRAND_TITLE;

/** Monograma cuadrado (icono de app). */
export const getMonogramByHostname = () => jcpIcon;

/** Hook con el monograma actual. */
export const useMonogram = () => jcpIcon;

export const getCompanyName = () => "Grupo Venelotto C.A.";
